import React from "react";
import { Route, Switch } from "react-router";

import Login from "@/scenes/Login";
import LoginSelectLoginMethod from "@/scenes/Login/SelectLoginMethod";
import Logout from "@/scenes/Logout";
import AppKeyLogin from "@/scenes/Login/AppKeyLogin";
import IndependentManualLogin from "@/scenes/Login/IndependentManual/IndependentManualLogin";
import IndependentManualRegister from "@/scenes/Login/IndependentManual/IndependentManualRegister";
import NotFound from "@/scenes/404";

interface AuthRoutesProps {}

/**
 * 登录认证相关路由
 */
const AuthRoutes: React.FC<AuthRoutesProps> = React.memo(function (props) {
    return (
        <Switch>
            <Route exact path="/login" component={Login} />

            {/* 平台登录 */}
            <Route exact path="/login/selectLoginMethod" component={LoginSelectLoginMethod} />

            {/* 此处后端302会回调到/appKeyLogin 所以暂时不能改为其他的页面 */}
            <Route exact path="/appKeyLogin" component={AppKeyLogin} />

            <Route exact path="/login/independentManual" component={IndependentManualLogin} />

            <Route exact path="/register/independentManual" component={IndependentManualRegister} />

            <Route exact path="/logout" component={Logout} />

            <Route component={NotFound} path="*" />
        </Switch>
    );
});

export default AuthRoutes;
